import { User } from 'types'

export const registerFullstoryUser = (user: User): void => {
    const { username: id, email, first_name, last_name } = user

    window.FS?.identify(id, {
        email,
        first_name,
        last_name,
    })
}
